import { ReactNode } from "react";
import { useModalState } from "../../context/ModalContext/ModalProvider";
import BaseButton from "../BaseButton";
import BaseIcon from "../BaseIcons";
import styles from "./baseAlert.module.scss";

type TAlert = {
  type?: string,
  message?: string
  children: ReactNode
}

const BaseAlert = ({ children }: TAlert) => {

  const { toggleModal, state } = useModalState();
  const { isVisible, message, type } = state;

  const typeButton = type === "error" ? "danger" : type;
  return (
    <div className={styles.main} data-testid="base-alert">
      <div className={`${isVisible ? styles.visible : styles.noVisible} ${styles.modal}`} data-testid="modal">
        <div className={styles.modal__content}>
          <div className={styles.modal__header}>
            <BaseIcon icon={`icon-${type}`} />
          </div>
          <div className={styles.modal__body} data-testid="modal-message">
            {message}
          </div>

          <div className={styles.modal__footer}>
            <BaseButton title="Cerrar" type={typeButton} onClick={() => toggleModal({ isVisible: false })} />
          </div>

        </div>


      </div>
      <div className={`${isVisible && styles.blur}`} data-testid="content-wrapper">
        {children}
      </div>
    </div>
  );
};


export default BaseAlert;